import React from "react";
import { Link } from "react-router-dom";
class GuitarAmps extends React.Component {
  render() {
    return (
      <li
        className="dropdown"
        onMouseEnter={() => this.props.open("Guitar")}
        onMouseLeave={this.props.close}
      >
        <a href="#" data-toggle="dropdown">
          Guitar Amps
          <b className="caret"></b>
        </a>
        <ul
          className="dropdown-menu"
          style={{
            visibility: this.props.opened == "Guitar" ? "visible" : "hidden",
          }}
        >
          <div className="pull-left size-control">
            <h5>Guitar Tube Amp Kits</h5>
            {this.props.amps.map((itemMap, key) => (
              <li onClick={this.props.close} key={key}>
                <Link to={itemMap.path}>{itemMap.name}</Link>
              </li>
            ))}
          </div>
        </ul>
      </li>
    );
  }
}

export default GuitarAmps;
